var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7834 2.84992C18.6844 2.45443 18.4828 2.09206 18.1989 1.79942C17.915 1.50679 17.559 1.29424 17.1667 1.18325C15.7334 0.833252 10 0.833252 10 0.833252C10 0.833252 4.2667 0.833252 2.83336 1.21659C2.44107 1.32757 2.08501 1.54012 1.80115 1.83276C1.51729 2.1254 1.31569 2.48776 1.2167 2.88325C0.954374 4.33788 0.826059 5.81351 0.833362 7.29159C0.824012 8.78079 0.952335 10.2677 1.2167 11.7333C1.32583 12.1165 1.53195 12.465 1.81515 12.7453C2.09835 13.0256 2.44905 13.2281 2.83336 13.3333C4.2667 13.7166 10 13.7166 10 13.7166C10 13.7166 15.7334 13.7166 17.1667 13.3333C17.559 13.2223 17.915 13.0097 18.1989 12.7171C18.4828 12.4244 18.6844 12.0621 18.7834 11.6666C19.0437 10.2229 19.172 8.75853 19.1667 7.29159C19.176 5.80238 19.0477 4.3155 18.7834 2.84992V2.84992Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 10.0167L12.9167 7.29165L8.125 4.56665V10.0167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1e04ec9f39641c8adfb265c0e40637bb.svg";
export { ForwardRef as ReactComponent };